import { Button, Icon } from '../../../atoms'
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from 'types/fs-core'
import Image from '../../imgix-img'
import classNames from 'classnames'

const zemplerApplicationSentMessage = {
  title: 'We’ve sent your application to Zempler bank',
  body: 'Zempler Bank will advise you of the outcome of your application via email within 1 working day –please ensure that you monitor your email inbox, including your Junk Inbox for this.<br/>  <br/>For questions about your account application, please contact Zempler directly on 0330 024 0924',
}

const zemplerInfo = {
  copy: {
    Approved: {
      title: 'We’re pleased to confirm that Zempler Bank have approved your application.',
      body: `<div>You will also receive these details in an email from Zempler Bank shortly – please ensure that you monitor your email inbox including junk and spam folders.<br/>  <br/>You should receive your card in the post to your home address within 3-5 working days. To activate the account, you simply need to ensure that you pay funds into the bank account within 60 days.<br/>  <br/>For questions about your account application, please contact Zempler directly on 0330 024 0924.</div>`,
    },
    InternalReview: zemplerApplicationSentMessage,
    DocsRequired: zemplerApplicationSentMessage,
    Duplicate: {
      title: 'It looks like there is already an existing application with Zempler bank',
      body: '<div>If you have any questions about the status of your application, please contact Zempler Bank directly.</div>',
    },
    Error: {
      title: "Hmm, something's not right.",
      body: "<div>Let's try that again. Please re-submit the form and we'll pick up where we left off</div>",
    },
  },
}

const ZemplerResults = ({ application }) => {
  return (
    <div className='ResultsCard'>
      <div className='ResultsCard__title'>
        {application.status === 'Approved' && (
          <Icon glyph='tick-circle-bg' size={48} desktopSize={64} fill='#924a8b' />
        )}
        <h2>{zemplerInfo.copy[application.status]?.title}</h2>
      </div>

      <div className='ResultsCard__details'>
        {application.status !== 'Error' && (
          <div className='ResultsCard__details__success'>
            {application.referenceNumber && (
              <div>
                <strong>Application Reference</strong>: {application.referenceNumber}
              </div>
            )}
            {application.sortCode && (
              <div>
                <strong>Sort Code</strong>: {application.sortCode}
              </div>
            )}
            {application.accountNumber && (
              <div>
                <strong>Account Number</strong>: {application.accountNumber}
              </div>
            )}
            {application.deliveryAddress_AddressLine && (
              <div>
                <strong>Delivery Address</strong>: {application.deliveryAddress_AddressLine}
              </div>
            )}
            {application.deliveryAddress_Postcode && (
              <div>
                <strong>Delivery Post Code</strong>: {application.deliveryAddress_Postcode}
              </div>
            )}
            {application.deliveryAddress_TownOrCity && (
              <div>
                <strong>Delivery City</strong>: {application.deliveryAddress_TownOrCity}
              </div>
            )}
          </div>
        )}
        <div
          className={classNames('ResultsCard__details__body', {
            'ResultsCard__details__body--fullwidth': application.status === 'Error',
          })}
          dangerouslySetInnerHTML={{ __html: zemplerInfo.copy[application.status]?.body }}
        />
      </div>
      {application.status === 'Approved' && (
        <div className='ResultsCard__get-started'>
          <h3>How to get started</h3>
          <div className='ResultsCard__steps'>
            <div className='ResultsCard__step'>
              <div className='ResultsCard__step-text'>
                <div className='ResultsCard__step-number'>1</div>
                <p>Download and log into the Zempler Bank app</p>
              </div>
              <div className='ResultsCard__app-buttons'>
                <a
                  href='https://apps.apple.com/gb/app/zempler-bank/id709473017'
                  target='_blank'
                  rel='noreferrer'
                  data-click-tracking={JSON.stringify({
                    additionalProps: { button: 'zempler app store' },
                  })}
                >
                  <Image
                    src={`https://www.money.co.uk/fs-core-assets/icons/money/get-it-app-store.svg`}
                    alt='App store'
                    critical={true}
                  />
                </a>
                <a
                  href='https://play.google.com/store/apps/details?id=co.uk.mycashplus.maapp&pcampaignid=web_share'
                  target='_blank'
                  rel='noreferrer'
                  data-click-tracking={JSON.stringify({
                    additionalProps: { button: 'zempler google play' },
                  })}
                >
                  <Image
                    src={`https://www.money.co.uk/fs-core-assets/icons/money/get-it-google-play.svg`}
                    alt='Google play store'
                    critical={true}
                  />
                </a>
              </div>
            </div>

            <div className='ResultsCard__step'>
              <div className='ResultsCard__step-text'>
                <div className='ResultsCard__step-number'>2</div>
                <p>
                  Add money – you&apos;ll need your sort code and account number, above (you can
                  copy and paste them straight from the app too).
                </p>
              </div>
            </div>

            <div className='ResultsCard__step'>
              <div className='ResultsCard__step-text'>
                <div className='ResultsCard__step-number'>3</div>
                <p>Activate your card and request your PIN.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {application.status !== 'Error' ? (
        <div className='ResultsCard__details__callout'>
          This service is provided by Advanced Payment Solutions Limited (APS), trading as Zempler
          Bank. Registered in England and Wales at Cottons Centre, Cottons Lane, London SE1 2QG
          (No.04947027). APS is authorised by the Prudential Regulation Authority and regulated by
          the Financial Conduct Authority and the Prudential Regulation Authority under Firm
          Reference Number 671140.
        </div>
      ) : (
        <div className='ResultsCard__details__backButton'>
          <Button
            variant='primary'
            size='sm'
            onClick={() => {
              history.back()
            }}
          >
            Go Back
          </Button>
        </div>
      )}
    </div>
  )
}

export default connect((state: FsCore.State, props: any) => {
  return {
    ...props,
    application: state.components.smeProviderApplication,
  }
})(ZemplerResults)
